<template>
  <div class="ma-0">
    <titleAgency />
    <!-- <filterAgency/>
    <tableAgency/> -->
    <v-tabs
      v-model="tab"
      color="#2BA197"
      background-color="titlebackground"
    >
      <v-tabs-slider class="ml-3" color="#2BA197"></v-tabs-slider>

      <v-tab v-for="item in items" :key="item" style="font-weight: 700;font-size: 16px;letter-spacing: 1px;">
        <span class="ml-5">{{ item }}</span>
      </v-tab>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <div class="my-2">
            <div>
              <!-- <tableAgency/> -->
              <filterGroup class="mx-5"/>
              <tableGroup class="mx-5"/>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div class="my-2">
            <div>
              <filterAgency class="mx-5"/>
              <tableAgency class="mx-5"/>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div class="my-2">
            <div>
              <filterPerson class="mx-5"/>
              <tablePerson class="mx-5"/>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import titleAgency from '@/components/_managerolecompany/_overview/title.vue'
import filterAgency from '@/components/_managerolecompany/_overview/filter.vue'
import filterGroup from '@/components/_managerolecompany/_overview/filterGroupCompany.vue'
import filterPerson from '@/components/_managerolecompany/_overview/filterPerson.vue'
import tableAgency from '@/components/_managerolecompany/_overview/table.vue'
import tableGroup from '@/components/_managerolecompany/_overview/tableGroup.vue'
import tablePerson from '@/components/_managerolecompany/_overview/tablePerson.vue'
export default {
  components: {
    titleAgency,
    filterAgency,
    filterPerson,
    tableAgency,
    tableGroup,
    filterGroup,
    tablePerson
  },
  data () {
    return {
      activeTab: 0,
      page: 'approve',
      render: true,
      tab: null,
      items: [
        'จัดการสิทธิ์ตามเครือ', 'จัดการสิทธิ์ตามบริษัท', 'จัดการสิทธิ์บุคคล'
      ]
    }
  },
  watch: {
    tab: function (val) {
      EventBus.$emit('resetFilterRole')
    }
  },
  methods: {
    changeTab (item) {
      this.forceRerender()
    },
    forceRerender () {
      if (this.activeTab === 0) {
        this.page = 'approve'
      } else if (this.activeTab === 1) {
        this.page = 'acknowledge'
      }
      this.render = false
      this.$nextTick(() => {
        this.render = true
      })
    }
  }
}
</script>

<style scoped>
.v-tab {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: "600";
  font-size: 1.2rem;
}
</style>
